import { ExtendedButtonProps } from "@components/general/Button/Button";
import { forwardRef } from "react";
import { useOrganizationContext } from "@state/organizationContext";
import { NavigationToggleBase } from "@components/navigation/NavigationToggleBase";

export const OrganizationViewNavigationDropdownToggle: React.FC<ExtendedButtonProps> =
    forwardRef(({ onClick }, ref) => {
        const { activeOrganization } = useOrganizationContext();

        return (
            <NavigationToggleBase
                onClick={onClick}
                text={activeOrganization?.name ?? ""}
                ref={ref as any}
            />
        );
    });
